module.exports = __webpack_public_path__ + "static/img/help2.8665db92.png";